var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-3"},[_c('b-card-group',{staticClass:"blokDeck justify-content-center",attrs:{"deck":""}},_vm._l((_vm.blocks),function(block){return _c('block-card',{key:block[0].blockid,attrs:{"block":block}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }